export enum AccountType {
  Current = '1-Current',
  Savings = '2-Savings',
  Transmission = '3-Transmission',
}

export enum IdType {
  ForeignPassport = 'FPP',
  SouthAfricanID = 'SID',
  SouthAfricanPassport = 'SPP',
  SouthAfricanBusiness = 'SBR',
}

export enum AccountOwnerKind {
  Company = 'company',
  Individual = 'individual',
}

export type AccountCompanyOwner = {
  kind: AccountOwnerKind.Company;
  companyName: string;
  companyRegistrationNumber: string;
  idType: IdType;
};

type AccountIndividualOwner = {
  kind: AccountOwnerKind.Individual;
  idNumber: string;
  idType: IdType;
  surname: string;
};

export enum BankName {
  firstNationalBank = 'FIRST NATIONAL BANK',
  nedbank = 'NEDBANK',
  standardBankSa = 'STANDARD BANK SA',
  standardBank = 'STANDARD BANK',
  absaBank = 'ABSA BANK',
  capitecBank = 'CAPITEC BANK',
  investec = 'INVESTEC',
  discoveryBank = 'DISCOVERY BANK',
  SASFIN = 'SASFIN',
  africanBank = 'AFRICAN BANK',
  absaBankLimited = 'ABSA BANK LIMITED',
  sasfinBankLimited = 'SASFIN BANK LIMITED',
  investecBank = 'INVESTEC BANK',
  tymeBankLimited = 'TYME BANK LIMITED',
  grindrodBank = 'Grindrod Bank',
  albarakaBank = 'ALBARAKA BANK',
  bankZero = 'BANK ZERO',
  bidvestBank = 'BIDVEST BANK',
  bnpParibas = 'BNP PARIBAS',
  citiBank = 'CITIBANK',
  finBond = 'FINBOND MUTUAL BANK',
  finBondEPE = 'FINBOND EPE',
  groBank = 'GROBANK LTD',
  hbzBank = 'HBZ BANK',
  hsbcBank = 'HSBC BANK',
  habibBank = 'HABIB OVERSEAS BANK',
  ithala = 'ITHALA',
  jpMorgan = 'JP MORGAN CHASE',
  lesothoPostBank = 'LESOTHO POST BANK',
  olympusMobile = 'OLYMPUS MOBILE',
  peoplesBank = 'PEOPLES BANK LTD INC NBS',
  postBank = 'POSTBANK',
  saReserve = 'S.A. RESERVE BANK',
  societeGenerale = 'SOCIETE GENERALE',
  standardChartered = 'STANDARD CHARTERED BANK',
  stateBankIndia = 'STATE BANK OF INDIA',
  uBank = 'UBANK LIMITED',
  vbsMutualBank = 'VBS MUTUAL BANK',
}

export type AccountOwner = AccountIndividualOwner | AccountCompanyOwner;
